/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-09-13 10:42:55
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\extendsFields\imgcode\index.tsx
 */

import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styles from './style.module.less';
@inject((store) => store)
@observer
@BindAll()
export class CompanyCurrencyLocation extends React.Component<{ onChange?: (value) => void, [key: string]: any; large?:boolean } > {
  @observable optionLists = []
  @observable extendInfo = {}
  @observable value = []
  @observable loading = false
  @observable currentlyProvide = '';

  @action
  setData(key, data){
    this[key] = data
  }

  get Currency() {
    return this.$Store.Currency
  }

  async getProvides(){
    const res:any = await this.Currency.enterpriseGetProvides()
    lodash.map(res, item => lodash.assign(item, {
      label: lodash.get(item, 'name'),
      value: lodash.get(item, 'code'),
      isLeaf:false,
    }))
    this.setData('optionLists', res)
  }

  async getCitys(targetOption){
    const {value} = targetOption
    const res:any = await this.Currency.enterpriseGetCitys(value)
    this.currentlyProvide = value;
    targetOption.children = lodash.map(res, item => lodash.assign(item, {
      label: lodash.get(item, 'name'),
      value: lodash.get(item, 'code'),
      isLeaf:false,
    }))
    this.setData('optionLists', [...this.optionLists])
  }

  async getDistrict(targetOption){
    const {value} = targetOption
    const res:any = await this.Currency.enterpriseGetDistrict({
      provincecode: this.currentlyProvide,
      citycode: value,
    })
    targetOption.children = lodash.map(res, item => lodash.assign(item, {
      label: lodash.get(item, 'name'),
      value: lodash.get(item, 'code'),
      isLeaf:true,
    }))
    this.setData('optionLists', [...this.optionLists])
  }

  loadData(selectedOptions){
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    if(selectedOptions.length === 1){
      this.getCitys(targetOption)
    }else if(selectedOptions.length === 2){
      this.getDistrict(targetOption)
    }
  }
 
  displayRender(label){
    return `${label[0]}/${label[1]}/${label[2]}`;
  }

  handleData(data){
    // let arr = []
    let hasEmpty = false
    lodash.forIn(data, (value, key) => {
      if (!value) {
        hasEmpty = true;
      }
      // arr.push({
      //   "field":key,
      //   "value":value
      // })
    })
    if (hasEmpty) {
      return null;
    }
    return data;
  }

  @action
  onChange(value, selectedOptions){
    if(!selectedOptions || !value){
      return
    }
    this.extendInfo = {
      provinceCode: value[0],
      province: lodash.get(selectedOptions, '[0].label'),
      cityCode: value[1],
      city: lodash.get(selectedOptions, '[1].label'),
      districtCode: value[2],
      district: lodash.get(selectedOptions, '[2].label'),
      formattedAddress: `${lodash.get(selectedOptions, '[0].label')}/${lodash.get(selectedOptions, '[1].label')}/${lodash.get(selectedOptions, '[2].label')}`
    } 
    this.setData('value', value)
    this.props.onChange(this.handleData(this.extendInfo))
  }

  async init(mapProvide, mapCity, mapDistrict){
    let defaultProvideOpt = lodash.find(this.optionLists, e => e.value === mapProvide)
    await this.getCitys(defaultProvideOpt)
    let defaultCityOpt = lodash.find(lodash.get(defaultProvideOpt, 'children'), e => e.value === mapCity)
    await this.getDistrict(defaultCityOpt)
    this.setData('value', [mapProvide, mapCity, mapDistrict])
  }

  async componentDidMount() {
    try {
      this.setData('loading', true)
      await this.getProvides()
      // this.init()
      const { _address } = await this.$GetAmap()
      if (lodash.size(_address)) {
        console.log("zhaoyu ~ _address", _address)
        this.setData('extendInfo', this.handleData({
          provinceCode: lodash.get(_address, '[0].value'),
          province: lodash.get(_address, '[0].label'),
          cityCode: lodash.get(_address, '[1].value'),
          city: lodash.get(_address, '[1].label'),
          districtCode: lodash.get(_address, '[2].value'),
          district: lodash.get(_address, '[2].label'),
          formattedAddress: `${lodash.get(_address, '[0].label')}/${lodash.get(_address, '[1].label')}/${lodash.get(_address, '[2].label')}`
        }) )
        await this.init(lodash.get(_address, '[0].value'), lodash.get(_address, '[1].value'), lodash.get(_address, '[2].value'))
        this.props.onChange(this.handleData(this.extendInfo))
      }
    } catch (error){
      console.log("zhaoyu ~ error", error)
    }
    this.setData('loading', false)
  }

  onClear(){
    console.log('cliear')
    this.setData('value', [])
  }
  
  render() {
    return (
      <div className={styles.location}>
      <React.Antd.Spin tip="" spinning={this.loading} className={styles.currencyLocationSpin}>
        <React.Icons.EnvironmentOutlined></React.Icons.EnvironmentOutlined>
        <React.Antd.Cascader
          className={this.props.large ? styles.currencyLocationLarge : styles.currencyLocation}
          // suffixIcon={<React.Icons.EnvironmentOutlined className={'prefixIcon'} />}
          onChange={this.onChange}
          value={toJS(this.value)}
          options={this.optionLists}
          loadData={this.loadData}
          displayRender={this.displayRender}
          placeholder="请选择省市区"
          onClear={this.onClear}
          allowClear={false}
          // changeOnSelect
          // {...(this.props as any)}
        />
      </React.Antd.Spin>
      </div>
    );
  }
}
